export const LARGE_AD_TEXT_LENGTH = 40;

export class BannerAdSizes {
  private height: number
  private width: number

  constructor(width: number, height: number) {
    this.width = width
    this.height = height
  }

  toGamSizing() {
    return [this.width, this.height]
  }

  toDtxSizing() {
    return {
      width: this.width,
      height: this.height
    }
  }
}

export const AD_SIZE = {
  small: new BannerAdSizes(320, 50),
  middle: new BannerAdSizes(300, 250),
};

export const getAdSize = (description: string) => {
    return description?.split(' ').length <= LARGE_AD_TEXT_LENGTH
        ? AD_SIZE.middle
        : AD_SIZE.small;
};
